import {Service} from '@frontapp/editor-html';

import {globalWindow} from '../../../../../libs/shared/core/src/helpers/browser/browserHelpers';
import {BaseChangeManager} from './baseChangeManager';
import {ChangeManager} from './changeManager';

/** Provides change notifications and dirty state tracking based on an editor service. */
export function createEditorServiceChangeManager(service: Service): ChangeManager {
  return new BaseChangeManager({
    subscribe: (subscriber) => {
      const subscription = service.changes$.subscribe(subscriber);
      return () => subscription.unsubscribe();
    },
    postChangeHandler: (callback) => globalWindow.setInstrumentedTimeout(callback, 0),
  });
}
